// INJECT_FROM_PLOP_TABLELIST
export const STORE_PURCHASE_ORDER = 'purchaseOrderStore'
export const STORE_AUTH = 'authStore'
export const STORE_CUSTOMER_INVOICE = 'customerInvoiceStore'
export const STORE_SITE_DOCUMENT = 'siteDocumentStore'
export const STORE_BACKUP_DOCUMENT = 'backupDocumentStore'
export const STORE_BIOHAZARDOUS_MANIFEST = 'biohazardousManifestStore'
export const STORE_WASTESTREAM = 'wastestreamStore'
export const STORE_ORDER = 'orderStore'
export const STORE_REPORT = 'reportStore'
export const STORE_COMPANY_CATEGORY = 'companyCategoryStore'
export const STORE_ACCOUNT_CATEGORY = 'accountCategoryStore'
export const STORE_TREATMENT_CATEGORY = 'treatmentCategoryStore'
export const STORE_TREATMENT_METHOD = 'treatmentMethodStore'
export const STORE_DASHBOARD = 'dashboardStore'
export const STORE_MANIFEST = 'manifestStore'
export const STORE_MOU = 'mouStore'
export const STORE_METADATA = 'metadataStore'
export const STORE_HELP_CENTER = 'helpCenterStore'
export const STORE_ANALYTIC = 'analyticStore'
export const STORE_PROFILE = 'profileStore'
export const STORE_METRIC_BY_PERIODS = 'metricByPeriodsStore'
export const STORE_KPI = 'kpiStore'
export const STORE_LOCATION = 'locationStore'
export const STORE_LOCATION_BY_PERIODS = 'locationByPeriodsStore'
export const STORE_AUDIT = 'auditStore'
export const STORE_REGISTRATION_DOCUMENT = 'registrationDocumentStore'
export const STORE_SERVICE_LOCATION = 'serviceLocationStore'
